import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./thankyou.css";
import { Helmet } from "react-helmet";

const ThankYou = () => {
  const navigate = useNavigate();

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="thank-you-container">
      <Helmet>
        <title>Thank You - Message Sent Successfully | Vasmi Group</title>
        <meta name="description" content="Thank you for getting in touch with Vasmi Group. Our team will contact you shortly." />
      </Helmet>
      <div className="thank-you-content">
        <div className="success-checkmark">
          <div className="check-icon">
            <span className="icon-line line-tip"></span>
            <span className="icon-line line-long"></span>
            <div className="icon-circle"></div>
            <div className="icon-fix"></div>
          </div>
        </div>
        <h1 className="thank-you-title">Thank You!</h1>
        <h2 className="thank-you-subtitle">Your message has been received.</h2>
        <p className="thank-you-description">
          We appreciate you reaching out to <strong>Vasmi Group</strong>. Our team is already reviewing 
          your request and will get back to you within 24 hours.
        </p>
        <div className="thank-you-actions">
          <button className="back-home-btn" onClick={() => navigate("/")}>
            Explore More
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
